'use client';

import { c as _c } from "react/compiler-runtime";
import MuxPlayer from '@mux/mux-player-react';
import { useState } from 'react';
import { createLogger } from '@/services/logger';
const logger = createLogger('MuxPlayerWrapper');
export type MuxPlayerWrapperProps = {
  errorMessage?: string;
  playbackId: string;
};
export const MuxPlayerWrapper = t0 => {
  const $ = _c(7);
  const {
    errorMessage,
    playbackId
  } = t0;
  const [hasError, setHasError] = useState(false);
  if (hasError) {
    let t1;
    if ($[0] !== errorMessage) {
      t1 = errorMessage ? <div className="error">{errorMessage}</div> : null;
      $[0] = errorMessage;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      video_title: "Home page banner"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = error => {
      logger.error({
        error
      }, "Mux player encountered an error");
      setHasError(true);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "--controls": "none",
      "--loading-indicator": "none",
      "--media-object-fit": "cover",
      "--media-object-position": "center",
      "--seek-backward-button": "none",
      "--seek-forward-button": "none",
      "--center-controls": "none",
      "--top-captions-button": "none",
      "--media-background-color": "transparent",
      "--media-poster-image-display": "none"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== playbackId) {
    t4 = <MuxPlayer autoPlay="muted" className="size-[100%]" disableCookies={true} disableTracking={true} loop={true} metadata={t1} muted={true} nohotkeys={true} onError={t2} playbackId={playbackId} poster="" preload="metadata" streamType="on-demand" style={t3} />;
    $[5] = playbackId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};